import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Utils } from '../../utils/utils';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ExcelDownloadConfig, ExcelUploadConfig } from '../../interfaces/utils/excelbuttoninterface';

@Component({
    selector: 'excelbuttons',
    template: `
    @if (!isExcelModeEnabled) {
      <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
        <span class='glyphicon glyphicon-th'></span> Excel
      </a>
    }
    
    @if (isExcelModeEnabled) {
      <a class='kpi-button-menu' title="Dowload" (click)="onClickDownload()">
        <span class='glyphicon glyphicon-download'></span> Download
      </a>
    }
    
    @if (isExcelModeEnabled) {
      <a class='kpi-button-menu' title="Upload" (click)="onClickUpload()">
        <span class='glyphicon glyphicon-upload'></span> Upload
      </a>
    }
    
    @if (isExcelModeEnabled) {
      <a class='kpi-button-menu' title="Excel" (click)="onClickExitExcel()">
        Exit Excel Mode
      </a>
    }
    `,
    standalone: false
})
export class ExcelbuttonsComponent implements OnInit {
    @Input() downloadConfig?: ExcelDownloadConfig;
    @Input() uploadConfig?: ExcelUploadConfig;
    @Output() disableEditMode = new EventEmitter<boolean>();

    private defualtFileName = 'download'; 
    isExcelModeEnabled = false;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router
    ) { }

    ngOnInit(): void {
    }

    onClickExcel() {
        this.isExcelModeEnabled = true;
        this.disableEditMode.emit(true);
    }

    onClickExitExcel() {
        this.isExcelModeEnabled = false;
    }

    //showUploadButton() {
    //    return this.uploadConfig?.uploadFunction || this.uploadConfig?.relatedUtil || this.uploadConfig?.uploadLink
    //}

    //showDownloadButton() {
    //    return this.downloadConfig?.downloadFunction || this.downloadConfig?.downloadLink;
    //}

    onClickUpload() {
        if (this.uploadConfig?.uploadFunction) {
            this.uploadConfig.uploadFunction();
        }
        else if (this.uploadConfig?.relatedUtil) {
            this.router.navigate(["file/" + this.uploadConfig?.relatedUtil]);
        }
        else if (this.uploadConfig?.uploadLink) {
            this.router.navigate([this.uploadConfig?.uploadLink]);
        }
    }

    onClickDownload() {
        if (this.downloadConfig?.downloadFunction) {
            this.downloadConfig.downloadFunction();
        }
        else if (this.downloadConfig?.downloadLink) {
            Utils.httpDownloadExcelGeneric(
                this.http,
                this.baseUrl,
                this.downloadConfig.downloadLink,
                this.downloadConfig.fileName ?? this.defualtFileName,
            );
        }
    }
}
